var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "url(#paint0_linear_6805_6516)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5587 12.4413L18.672 21.328M12.7259 16.8627L26.5642 12.0617C27.4164 11.766 28.234 12.5836 27.9383 13.4358L23.1373 27.2741C22.8084 28.2221 21.4771 28.2481 21.1115 27.3136L18.9141 21.698C18.8043 21.4176 18.5824 21.1957 18.302 21.0859L12.6864 18.8885C11.7519 18.5229 11.7779 17.1916 12.7259 16.8627Z",
    stroke: "#FAFDFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6805_6516",
    x1: 0,
    y1: 20,
    x2: 40,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#799DD2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentButton);
export default __webpack_public_path__ + "static/media/CommentButton.3f80d1e6bdc2e91ba5403ca4187dd39c.svg";
export { ForwardRef as ReactComponent };